module.exports = __webpack_public_path__ + "static/media/Logo-str.3777ece4.png";